import React from 'react';
import { Fade } from 'react-reveal';
import ProjectsImg from './ProjectsImg';
import ProjectsData from './projects.json';
import './ProjectsGreeting.css';
import GithubRepoCard from './githubRepoCard/GithubRepoCard';

const ProjectsGreeting = () => {
  return (
    <div className='projects-main'>
      <div className='basic-projects'>
        <Fade bottom duration={2000} distance='40px'>
          <div className='projects-heading-div'>
            <div className='projects-heading-img-div'>
              <ProjectsImg />
            </div>
            <div className='projects-heading-text-div'>
              <h1 className='projects-heading-text'>Projects</h1>
              <p className='projects-header-detail-text subTitle'>
                These projects make use of vast variety of latest technology
                tools. The best experience is to create React.js projects and
                deploy them to web applications.
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <div className='repo-cards-div-main'>
        {ProjectsData.data.map((repo) => {
          return <GithubRepoCard repo={repo} />;
        })}
      </div>
    </div>
  );
};

export default ProjectsGreeting;
